import { Button, Form, RefreshIcon, TextButton } from '@thefarmersfront/kitchen';

import styles from './SearchFilter.module.scss';

const SearchFilter = ({
  formId = 'search-filter-form',
  children,
  onSubmit,
  onReset,
}: {
  formId?: string;
  children: React.ReactNode;
  onSubmit: () => void;
  onReset: () => void;
}) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <Form className={styles['search-filter-container']} onSubmit={handleSubmit} id={formId}>
      <div className={styles['filters-container']}>{children}</div>
      <div className={styles['actions-container']}>
        <Button className={styles['search-button']} size="small" type="submit" form={formId}>
          검색
        </Button>
        <TextButton
          className={styles['reset-button']}
          leftIcon={<RefreshIcon size={16} />}
          size="small"
          color="secondary"
          onClick={onReset}
        >
          필터 초기화
        </TextButton>
      </div>
    </Form>
  );
};

export default SearchFilter;
